export default __webpack_public_path__ + "static/media/7.d1d0eabe.webp";